export default function SpeakToADoctorIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.61225 3.57143H3.57143C2.15114 3.57143 1 4.72257 1 6.14286V13C1 14.4203 2.15114 15.5714 3.57143 15.5714H5.28571V19L9.57143 15.5714H13.8571C15.2774 15.5714 16.4286 14.4203 16.4286 13V12.3878M10.1837 6.96144H13.0386V9.81633H16.1451V6.96144H19V3.85489H16.1451V1H13.0386V3.85489H10.1837V6.96144Z"
        stroke="#4E7FFF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
